// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"957a9d6c","455":"a974aec5","512":"3b0e79b3","585":"3c3a03f7","735":"f8d5c847","836":"b4685de6","840":"7397e802","857":"c85113df","885":"fc9c31ce","890":"b6a6898f","977":"86d65106"}[chunkId] + ".chunk.js";
};